import queryString from "query-string";

/** Campaign page tabs that can be opened from a link, as `/campaign/:id?tab=<CampaignTab>`. */
export type CampaignTab = "settings";

/** A field the opened tab should scroll into view, as `?focus=<CampaignFocus>`. */
export type CampaignFocus = "market";

const labels: Record<CampaignTab, string> = {
	"settings": "Settings",
};

/**
 * The index of the requested tab among the tabs the page is showing, or undefined when the query
 * string names no tab we know — the page then opens on its default tab.
 */
export const getCampaignTabIndex = (search: string, tabLabels: string[]): number | undefined => {
	const { tab } = queryString.parse(search);
	const label = typeof tab === "string" && Object.prototype.hasOwnProperty.call(labels, tab)
		? labels[tab as CampaignTab]
		: undefined;
	const index = label ? tabLabels.indexOf(label) : -1;
	return index >= 0 ? index : undefined;
};

/** The field the link asks the page to bring into view, or undefined. */
export const getCampaignFocus = (search: string): CampaignFocus | undefined => {
	const { focus } = queryString.parse(search);
	return focus === "market" ? focus : undefined;
};
